export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4.01 4 4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6c-1.1 0-1.99.9-1.99 2M13 3.5 18.5 9H13z\"/>"
};